<template>
   <v-dialog v-model="visible" fullscreen>
        <v-card>
            <v-card-title class="mb-6">
                <v-spacer/>
                <span>
                    {{ item ? 'Detalhes do Produto' : 'Detalhes do Pedido' }}
                </span>
                <v-spacer/>
                <v-btn icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text v-if="item">
                <v-row>
                    <v-col cols="12">
                        <b>{{ item.descricao }}</b>
                    </v-col>
                </v-row>

                <StepsList :item="item"/>

                <div v-for="(product, i) in item.produtos" :key="i" class="mt-1">
                    <v-row class="ml-1">
                        <v-col cols="12">
                            <b>{{ product.descricao }}</b>
                        </v-col>
                    </v-row>

                    <StepsList :item="product" :tab="8" :combo="true"/>

                    <v-divider style="margin: 5px;"/>
                </div>

                <v-divider/>

                <v-row class="mt-1">
                    <v-col cols="12">
                        <i>{{ item.observacao }}</i>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text
                v-else
                :style="`max-width: 800px; margin: auto; max-height: ${$vuetify.breakpoint.height - 130}px; overflow-x: auto; padding: 30px; border: 1px solid #ddd; border-radius: 5px;`"
            >
                <v-row>
                    <v-col cols="12" sm="6">
                        <b>DATA/HORA:</b> {{ datahora(value.created_at) }}
                    </v-col>
                </v-row>
                <v-divider class="my-4"/>
                <v-row>
                    <v-col>
                        <b>FORMA DE ENTREGA:</b> {{ getEntrega(value.entrega) }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-select
                            @change="onFormaPgtoChange"
                            v-model="form.forma_pagamento"
                            :items="formasPagamento"
                            label="Forma de Pagamento"
                            item-value="id"
                            item-text="descricao"
                            hide-details
                            outlined
                            dense
                        >
                            <template v-slot:selection="{ item }">
                                {{ item.descricao }}
                                <AcrescimoDescontoChips
                                    :item="item"
                                />
                            </template>
                            <template v-slot:item="{ item }">
                                {{ item.descricao }}
                                <AcrescimoDescontoChips
                                    :item="item"
                                />
                            </template>
                        </v-select>
                        <span v-if="valorAcrescimo(form.forma_pagamento)">
                            Acréscimo: {{ moeda() }}{{ formatPrice(valorAcrescimo(form.forma_pagamento)) }}
                        </span>
                    </v-col>
                </v-row>
                <v-row v-if="isDelivery">
                    <v-col>
                        <v-text-field
                            @change="atualizarTotais"
                            :readonly="isFinalizado"
                            label="Taxa de Entrega"
                            v-model="form.valor_frete"
                            v-mask="['#.##','##.##','###.##','####.##','#####.##']"
                            :prefix="moeda()"
                            hide-details
                            outlined
                            dense
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            @change="onAcrescimoDescontoChange"
                            v-model="form.desconto"
                            label="Desconto"
                            :prefix="moeda()"
                            placeholder="0.00"
                            v-mask="['#.##','##.##','###.##','####.##','#####.##']"
                            hide-details
                            outlined
                            dense
                        />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            @change="onAcrescimoDescontoChange"
                            v-model="form.acrescimo"
                            label="Acréscimo"
                            :prefix="moeda()"
                            placeholder="0.00"
                            v-mask="['#.##','##.##','###.##','####.##','#####.##']"
                            hide-details
                            outlined
                            dense
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                        <b>TOTAL PRODUTOS:</b> {{ moeda() }} {{ formatPrice(getSubtotalGeral) }}
                    </v-col>
                    <v-col cols="12" sm="6">
                        <b>TOTAL FINAL:</b> {{ moeda() }} {{ formatPrice(+value.total || 0) }}
                    </v-col>
                    <v-col v-if="cobrarIfood !== null" cols="12">
                        <b v-if="cobrarIfood > 0">COBRAR DO CLIENTE: {{ moeda() }} {{ formatPrice(cobrarIfood) }}</b>
                        <b v-else>PAGO NO iFOOD</b>
                    </v-col>
                </v-row>
                <v-row v-if="isDelivery">
                    <v-col>
                        <v-text-field
                            :readonly="isFinalizado"
                            label="Troco para:"
                            v-model="form.troco"
                            v-mask="['#.##','##.##','###.##','####.##','#####.##']"
                            hide-details
                            outlined
                            dense
                        />
                        <div v-if="(+form.troco - valorACobrar) > 0">
                            <span class="caption">
                                <b>VLR. TROCO:</b> {{ moeda() }} {{ formatPrice(form.troco - valorACobrar) }}
                            </span>
                        </div>
                    </v-col>
                </v-row>
                <v-divider class="my-4"/>
                <div v-if="isDelivery" class="mb-4">
                    <v-row>
                        <v-col cols="12" sm="4">
                            <v-text-field
                                :readonly="!editandoEndereco"
                                :filled="!editandoEndereco"
                                :label="codigoPostalDaLoja.rotulo"
                                v-model="form.cep"
                                v-mask="[codigoPostalDaLoja.mascara]"
                                hide-details
                                outlined
                                dense
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field
                                :readonly="!editandoEndereco"
                                :filled="!editandoEndereco"
                                label="Município"
                                v-model="form.municipio"
                                hide-details
                                outlined
                                dense
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field
                                :readonly="!editandoEndereco"
                                :filled="!editandoEndereco"
                                label="Bairro"
                                v-model="form.bairro"
                                hide-details
                                outlined
                                dense
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field
                                :readonly="!editandoEndereco"
                                :filled="!editandoEndereco"
                                label="Rua"
                                v-model="form.rua"
                                hide-details
                                outlined
                                dense
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field
                                :readonly="!editandoEndereco"
                                :filled="!editandoEndereco"
                                label="Número"
                                v-model="form.numero"
                                hide-details
                                outlined
                                dense
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-radio-group
                                v-model="form.tipo_local"
                                :disabled="!editandoEndereco"
                                :readonly="!editandoEndereco"
                                row
                                hide-details
                                style="margin-top: 5px;"
                            >
                                <v-radio
                                    label="Casa"
                                    value="casa"
                                />
                                <v-radio
                                    label="Apartamento"
                                    value="apartamento"
                                />
                                <v-radio
                                    label="Trabalho"
                                    value="trabalho"
                                />
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row v-if="form.tipo_local === 'apartamento'">
                        <v-col cols="6">
                            <v-text-field
                                :readonly="!editandoEndereco"
                                :filled="!editandoEndereco"
                                hide-details
                                label="Nome do prédio"
                                v-model="form.nome_edificio"
                                outlined
                                dense
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                :readonly="!editandoEndereco"
                                :filled="!editandoEndereco"
                                hide-details
                                label="Nº do apartamento"
                                v-model="form.numero_apartamento"
                                outlined
                                dense
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                :readonly="!editandoEndereco"
                                :filled="!editandoEndereco"
                                label="Complemento"
                                v-model="form.complemento"
                                hide-details
                                outlined
                                dense
                            />
                        </v-col>
                    </v-row>
                </div>
                <v-row>
                    <v-col>
                        <v-text-field
                            label="Observação"
                            v-model="form.observacao"
                            hide-details
                            outlined
                            dense
                        />
                    </v-col>
                </v-row>
                <v-row v-if="isDelivery && !isFinalizado">
                    <v-col>
                        <v-btn
                            v-if="!editandoEndereco"
                            @click="editandoEndereco = true"
                            color="primary"
                            outlined
                        >
                            <v-icon>mdi-pencil</v-icon>
                            Editar endereço
                        </v-btn>
                        <div v-else class="caption success--text">
                            <v-icon small color="success">mdi-pencil</v-icon>
                            Editando o endereço <b>deste pedido</b> — salve o pedido para aplicar (não altera o cadastro do cliente).
                        </div>
                    </v-col>
                </v-row>
                <div class="mt-4">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="callWhatsapp()"
                                fab
                                icon
                                color="success"
                                :disabled="!value.whatsapp"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon>mdi-whatsapp</v-icon>
                            </v-btn>
                        </template>
                        <span>Chamar no WhatsApp</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="callPhone()"
                                fab
                                icon
                                color="pink"
                                :disabled="!value.whatsapp"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon>mdi-phone</v-icon>
                            </v-btn>
                        </template>
                        <span>Ligar</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="viewLocation()"
                                fab
                                icon
                                color="cyan"
                                :disabled="!getEndereco()?.coordenadas"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon>mdi-map-marker</v-icon>
                            </v-btn>
                        </template>
                        <span>Ver localização</span>
                    </v-tooltip>
                </div>

                <div v-if="mergedHistorico.length">
                    <v-divider/>
                    <h2 class="title text-center mt-4">Histórico</h2>
                    <v-timeline align-top dense>
                        <v-timeline-item
                            :color="i % 2 ? 'pink' : 'teal lighten-3'"
                            small
                            v-for="(h, i) in mergedHistorico"
                            :key="i"
                        >
                            <v-row class="pt-1">
                                <v-col cols="3">
                                    <strong>{{ formatInstante(h.updated_at, 'HH:mm') }}</strong>
                                </v-col>
                                <v-col>
                                    <strong>{{ translate(h.status) }}</strong>
                                    <div v-if="h.user_id" class="text-caption">
                                        por {{ h.user_id }} - {{ h.user_name }}
                                    </div>
                                    <div class="text-caption">
                                        em {{ formatInstante(h.updated_at) }}
                                    </div>

                                    <template v-if="h.produtos?.length">
                                        <v-divider/>
                                        <div class="text-caption">
                                            <b>Produtos:</b>
                                        </div>
                                        <div
                                            v-for="(produto, j) in h.produtos"
                                            :key="j"
                                            class="text-caption"
                                        >
                                            {{ produto.quantidade }}x {{ produto.descricao }}
                                        </div>
                                        <v-divider/>
                                        <div class="text-caption">
                                            <b>TOTAL:</b> {{ moeda() }}{{ formatPrice(h.total) }}
                                        </div>
                                    </template>

                                    <template v-else-if="h.descricao">
                                        <v-divider/>
                                        <div class="text-caption">
                                            {{ h.descricao }}
                                        </div>
                                    </template>
                                </v-col>
                            </v-row>
                        </v-timeline-item>
                    </v-timeline>
                </div>
            </v-card-text>
        </v-card>
        <v-footer fixed class="pa-4" style="max-width: 800px; margin: auto;">
            <v-btn color="primary" @click="close" block>Voltar</v-btn>
        </v-footer>
    </v-dialog>
</template>

<script>
import StepsList from './StepsList';
import AcrescimoDescontoChips from './Pedido/AcrescimoDescontoChips';
import {
    subtotal,
    subtotalGeral,
} from '@/utils/calc';
import { mapState } from 'vuex';
import { pais, telefoneInternacional } from '@/utils/paises';

export default {
    name: 'DialogDetalhes',

    components: {
        StepsList,
        AcrescimoDescontoChips,
    },

    props: [
        'visible',
        'item',
        'value',
    ],

    data: () => ({
        form: {},
        saving: false,
        editandoEndereco: false,
    }),

    computed: {
        ...mapState([
            'formasPagamento',
            'formasEntrega',
            'configuracoes',
        ]),

        // CEP no Brasil, ZIP code na loja americana.
        codigoPostalDaLoja() {
            return pais(this.configuracoes?.pais).codigoPostal;
        },

        isDelivery() {
            return this.value.entrega == 2;
        },

        isFinalizado() {
            return this.value.finalizado;
        },

        // No iFood o total é o valor da loja; o cliente paga o que o iFood deixou para cobrar.
        cobrarIfood() {
            return this.value.origem === 'ifood' && this.value.ifood_cobrar != null
                ? +this.value.ifood_cobrar
                : null;
        },

        valorACobrar() {
            return this.cobrarIfood ?? (+this.value.total || 0);
        },

        getSubtotalGeral() {
            return subtotalGeral(this.value?.produtos || []);
        },

        mergedHistorico() {
            const alteracoes = this.value?.alteracoes_historico || [];
            const status = this.value?.status_historico || [];

            const merged = [...alteracoes, ...status];

            return merged.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
        },
    },

    watch: {
        value(pedido) {
            this.fillForm(pedido);
        },

        visible(v) {
            v ? this.fillForm(this.value) : this.$emit('close');
        },
    },

    methods: {
        fillForm(pedido) {
            this.editandoEndereco = false;
            const endereco = this.getEndereco();

            // Monta o form numa ÚNICA atribuição (reativo). Antes, quando não havia
            // endereço de cliente (caso iFood), o form era preenchido por atribuições
            // soltas que o Vue 2 não torna reativas → taxa e endereço não apareciam.
            this.form = {
                ...endereco,
                troco: pedido.troco,
                valor_frete: pedido.valor_frete,
                forma_pagamento: pedido.forma_pagamento,
                acrescimo: pedido.acrescimo,
                desconto: pedido.desconto,
                // cliente.enderecos guarda o complemento em `referencia` (o snapshot
                // iFood já é normalizado p/ esse shape no getEndereco).
                complemento: endereco.referencia,
                observacao: this.value.observacao || endereco.observacao,
            };

            this.saveAddress();
        },

        saveAddress() {
            this.value.observacao = this.form.observacao;
            this.value.troco = this.form.troco;
            this.value.valor_frete = this.form.valor_frete;
            this.value.forma_pagamento = this.form.forma_pagamento?.id || this.form.forma_pagamento || null;
            this.value.acrescimo = this.form.acrescimo;
            this.value.desconto = this.form.desconto;

            // Edição do ENDEREÇO do pedido: grava no SNAPSHOT (value.endereco) e só
            // quando o usuário editou. Afeta apenas este pedido — o cadastro do cliente
            // não é tocado (o backend, no update, não faz upsert de endereço). Persiste
            // ao salvar o pedido no DialogComanda.
            if (this.editandoEndereco) {
                this.value.endereco = {
                    ...(this.value.endereco || {}),
                    municipio: this.form.municipio,
                    bairro: this.form.bairro,
                    cep: this.form.cep,
                    rua: this.form.rua,
                    numero: this.form.numero,
                    complemento: this.form.complemento,
                    tipo_local: this.form.tipo_local,
                    nome_edificio: this.form.nome_edificio,
                    numero_apartamento: this.form.numero_apartamento,
                };
            }
        },


        // Endereço do cliente cadastrado; fallback p/ o snapshot do pedido (pedido
        // iFood não tem endereço no cliente — vem em value.endereco, com chaves
        // levemente diferentes, então normalizamos p/ o shape do endereço do cliente).
        getEndereco() {
            // Fonte da verdade = SNAPSHOT do pedido (value.endereco). O endereço do
            // cliente ao vivo (cliente.enderecos[0]) só entra como FALLBACK de legado
            // (pedidos antigos sem snapshot) — assim editar o cadastro do cliente nunca
            // altera o endereço de um pedido já lançado.
            const snap = this.value.endereco;
            if (snap && Object.keys(snap).length) {
                return {
                    municipio: snap.municipio || snap.cidade,
                    bairro: snap.bairro,
                    rua: snap.rua,
                    numero: snap.numero,
                    referencia: snap.complemento || snap.referencia,
                    cep: snap.cep,
                    tipo_local: snap.tipo_local,
                    nome_edificio: snap.nome_edificio,
                    numero_apartamento: snap.numero_apartamento,
                    coordenadas: snap.coordenadas,
                };
            }

            const cli = this.value.cliente?.enderecos?.[0];
            if (cli && Object.keys(cli).length) {
                return cli;
            }

            return {};
        },

        editarCliente() {
            this.close();
            this.$emit('editarCliente');
        },

        close() {
            this.saveAddress();
            this.$emit('close');
        },

        callWhatsapp() {
            const phone = telefoneInternacional(this.value.whatsapp, this.value.whatsapp_ddi);
            window.open(`https://api.whatsapp.com/send?phone=${phone}`);
        },

        callPhone() {
            const phone = this.value.whatsapp.replace(/\D/g, '');
            window.open('tel:' + phone);
        },

        viewLocation() {
            if (!this.getEndereco()?.coordenadas) {
                this.notify('Cliente não enviou a localização', 'warning');
                return;
            }

            const c = this.getEndereco().coordenadas;
            window.open(`https://maps.google.com/?q=${c.latitude},${c.longitude}`);
        },

        getEntrega(id) {
            return (this.formasEntrega?.find(e => e.id == id))?.descricao || '';
        },

        getPagamento(id) {
            return (this.formasPagamento?.find(e => e.id == id))?.descricao || '';
        },

        datahora(dh) {
            return dh ? this.moment(dh).format('DD/MM/YYYY HH:mm') : '';
        },

        valorAcrescimo(formaPgtoId) {
            if (!formaPgtoId) {
                return 0;
            }

            const formaPgto = this.formasPagamento.find(f => f.id == formaPgtoId);

            const totPed = this.getSubtotalGeral + +this.value.valor_frete;
            const percentual = +(formaPgto.acrescimo_percentual || 0);
            const valor = +(formaPgto.acrescimo_valor) || 0;

            let acrescimo = 0;

            valor && (acrescimo += valor);
            percentual && (acrescimo += totPed * percentual / 100);

            return Math.round((acrescimo || 0) * 100) / 100;
        },

        translate(s) {
            if (s == 'pago') return 'Pago';
            if (s == 'recebido') return 'Recebido';
            if (s == 'concluido') return 'Concluido';
            if (s == 'cancelado') return 'Cancelado';
            if (s == 'confirmado') return 'Confirmado';
            if (s == 'em_preparacao') return 'Em Preparação';
            if (s == 'aguardando_retirada') return 'Aguardando Retirada';
            if (s == 'saiu_para_entrega') return 'Saiu para Entrega';
            return s;
        },

        onAcrescimoDescontoChange() {
            this.atualizarTotais();
        },

        onFormaPgtoChange() {
            this.updateAcrescimoDesconto();
        },

        updateAcrescimoDesconto() {
            const formaPgto = this.formasPagamento.find(e => e.id == this.form.forma_pagamento);

            const taxaEntrega = this.isDelivery ? +(this.form.valor_frete || 0) : 0;
            const produtos = this.value.produtos.reduce((a, b) => a + +subtotal(b), 0) || 0;
            const totalBase = produtos + taxaEntrega;

            const acrescimoPercentual = +formaPgto?.acrescimo_percentual || 0;
            const acrescimoValor = +formaPgto?.acrescimo_valor || 0;
            const descontoPercentual = +formaPgto?.desconto_percentual || 0;
            const descontoValor = +formaPgto?.desconto_valor || 0;

            const acrescimo = ((totalBase * acrescimoPercentual) / 100) + acrescimoValor;
            const desconto = ((totalBase * descontoPercentual) / 100) + descontoValor;

            this.form.acrescimo = acrescimo ? acrescimo.toFixed(2) : null;
            this.form.desconto = desconto ? desconto.toFixed(2) : null;

            this.atualizarTotais();
        },

        atualizarTotais() {
            const produtos = subtotalGeral(this.value.produtos);
            const taxaEntrega = this.isDelivery ? +(this.form.valor_frete || 0) : 0;
            const total = produtos + taxaEntrega + (+this.form.acrescimo || 0) - (+this.form.desconto || 0);

            this.value.total = total;

            this.$forceUpdate();
        },
    }
}
</script>

<style scoped>
.v-card__text, .v-card__title {
    word-break: normal;
    /* maybe !important  */
}

.v-card__title {
    padding: 0 16px 0 16px;
    font-size: 15px;
    height: 35px !important;
}
</style>
